import { memo, type ReactNode } from 'react';

import {
  SideNavTrayListItemActions,
  SideNavTrayListItemBody,
  SideNavTrayListItemContent,
  SideNavTrayListItemRoot,
  SideNavTrayListItemStatus,
  SideNavTrayListItemTitle,
} from '~/components/v2/components/workspace/main-side-nav/SideNavTrayListItem';
import { WorkspaceImportsListItemThumbnail } from '~/components/v2/components/workspace/workspace-imports/WorkspaceImportsListItemThumbnail';
import { type WorkspaceImportRow } from '~/components/v2/components/workspace/workspace-imports/workspaceImportTypes';

export type WorkspaceImportsListItemProps = {
  actions: ReactNode;
  dimmed: boolean;
  row: WorkspaceImportRow;
};

export const WorkspaceImportsListItem = memo(({ actions, dimmed, row }: WorkspaceImportsListItemProps) => (
  <SideNavTrayListItemRoot data-import-id={row.id} testId="WORKSPACE_IMPORTS_ITEM">
    <SideNavTrayListItemContent dimmed={dimmed}>
      <WorkspaceImportsListItemThumbnail row={row} />
      <SideNavTrayListItemBody>
        <SideNavTrayListItemTitle testId="WORKSPACE_IMPORTS_ITEM_TITLE">{row.title}</SideNavTrayListItemTitle>
        <SideNavTrayListItemStatus testId="WORKSPACE_IMPORTS_ITEM_STATUS">{row.statusCopy}</SideNavTrayListItemStatus>
      </SideNavTrayListItemBody>
    </SideNavTrayListItemContent>
    {actions ? <SideNavTrayListItemActions fadeOnHover={!dimmed}>{actions}</SideNavTrayListItemActions> : null}
  </SideNavTrayListItemRoot>
));

WorkspaceImportsListItem.displayName = 'WorkspaceImportsListItem';
